import styled from 'styled-components';
import {
  black,
  border1,
  boxShadow1,
  gray,
} from '../../../../utils/style/colors';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 0.5rem;
  background: var(--exact-white);
  height: 100%;
  border: none !important;
  gap: 0.5rem;
`;

export const ListItemContainer = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;

  & > img {
    margin-inline-end: 0;
    cursor: pointer;
  }
`;

export const MainHeader = styled.h4`
  flex: 1;
  font-size: 1.25rem !important;
  font-weight: bold;
  color: ${black};
  margin: 0 !important;
`;

export const QuillContainer = styled.div`
  height: calc(100% - 1rem);
  max-height: ${boxShadow1};
  display: block;
  flex-flow: column;
  overflow: hidden;
  z-index: 30000000 !important;
  opacity: 1;
  top: 10%;
  margin: 1rem;
  border-radius: 1rem;
  background-color: var(--exact-white);
  box-shadow: 0 0 0.5rem ${gray};
`;

export const PreviewHTML = styled.div`
  width: 100%;
  height: 50%;
  overflow: auto;
  border: ${border1};
  border-radius: 0.5rem;
  padding: 0.5rem;
`;

export const HTMLEditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & > h4 {
    padding-top: 1rem;
    font-weight: bold;
  }
`;
